import { Component, NgModule, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { AuthService, IUser } from '../../services';
import { UserPanelModule } from '../user-panel/user-panel.component';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { Router } from '@angular/router';
import { TranslationService } from '../../services/i18n/translation.service';
import { TranslateService } from '@ngx-translate/core';
import { SharedModule } from '../../modules/shared/shared.module';
import { SharedComponentModule } from 'src/app/shared-component/shared-component.module';
import { genericCustomStoreService } from '../../services/genericCustomStore.service';
import { DxMenuModule } from 'devextreme-angular';
import { ThemeSelectorModule } from "../theme-selector/theme-selector.component";
@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  // //menu
  // sessiondata: any = []
  // data: any;
  // previousparent: any = []
  // identifier: number = 0
  // previous: number = 0
  // showSubmenuModes: any = {}
  // //
  // popupVisible = false;
  // closeButtonOptions: any;
  // positionOf: string;
  // backButtonOptions: any;
  // @Output()
  // menuToggle = new EventEmitter<boolean>();
  // @Output() _collapsed = new EventEmitter<boolean>(false)

  // @Input()
  // menuToggleEnabled = false;

  // @Input()
  // title!: string;
  // private collapsedState = false
  // user: IUser | null = { userName: '' };
  // cdcsetting: boolean = false;
  // userstatus: any = sessionStorage.getItem('data');

  // userMenuItems = [
  //   {
  //     text: 'changepassword',
  //     icon: 'user',
  //     onClick: () => {
  //       this.router.navigate(['/change-password']);
  //     }
  //   },
  //   {
  //     text: this.userstatus == null ? 'Login' : 'Logout',
  //     icon: this.userstatus == null ? 'unlock' : 'runner',
  //     onClick: () => {
  //       sessionStorage.removeItem('token');
  //       sessionStorage.removeItem('data');
  //       sessionStorage.removeItem('username')
  //       this.authService.logOut();
  //     }
  //   }];

  // languageSettings = [
  //   {
  //     id: 'en',
  //     name: window.localStorage.getItem("Language") == 'en' ? 'english' : 'اللغة الانجليزية'
  //   },
  //   {
  //     id: 'ar',
  //     name: window.localStorage.getItem("Language") == 'en' ? 'arabic' : 'اللغة العربية'
  //   }
  // ]

  // Language: any = window.localStorage.getItem("Language") == 'en' ? 'lang.en' : 'lang.ar'

  // constructor(private authService: AuthService, public gt: genericCustomStoreService, private location: Location, private router: Router, public tanslationService: TranslationService, public translate: TranslateService) {
  //   this.gt.$HOMETAB.subscribe(res => {
  //     res ? this.popupVisible = false : ''
  //   })
  //   const that = this;
  //   this.closeButtonOptions = {
  //     icon: 'close',
  //     onClick(e: any) {
  //       that.popupVisible = false;
  //     },
  //   };
  //   this.backButtonOptions = {
  //     text: window.localStorage.getItem("Language") == 'en' ? 'Content' : 'محتوى',
  //     icon: 'spindown',
  //     onClick: () => {
  //       that.popupVisible = true;
  //     }
  //   }
  //   this.showSubmenuModes = {
  //     name: 'onHover',
  //     delay: { show: 0, hide: 300 },
  //   }
  // }



  // backToPrevious(e: any) {
  //   console.log(e);
  //   if (window.history.length > 1) {
  //     this.location.back();
  //   } else {
  //     this.router.navigate(['/']);
  //   }
  // }

  // async ngOnInit() {

  //   const setting = localStorage.getItem('cdcSetting');
  //   this.cdcsetting = setting !== null ? JSON.parse(setting) : false;
  //   this.authService.getUser().then((e) => this.user = e.data);
  //   //menu
  //   this.sessiondata = await sessionStorage.getItem("data");
  //   this.data = JSON.parse(this.sessiondata);
  //   this.data = this.data?.navihationMenu
  //   //make parent and child from data
  //   if (this.data) {
  //     this.data.forEach((ele: any) => {
  //       ele.items = []
  //       this.data.filter((filterele: any) => {
  //         ele.id == filterele.parentId ? ele.items.push(filterele) : ''
  //       })
  //     })

  //     //filter data 
  //     this.data.forEach((ele: any) => {
  //       this.data = this.data.filter((res: any) => {
  //         return !ele.items.includes(res)
  //       })
  //     })

  //   }
  // }

  // toggleMenu = () => {
  //   this.menuToggle.emit();
  // }

  // onItemClick(e: any) {
  //   this.tanslationService?.changeLang(e.itemData.id)
  // }

  // itemClick(e: any) {
  //   this.router.navigate([e.itemData.externalUrl])
  // }

  @Input()
  menuToggleEnabled = false;
  private collapsedState = false
  translation: string = ''
  toggeltranslation: boolean = false
  popupsearch: boolean = false
  data: any
  rootMenus: any[] = [];

  @Output() _collapsed = new EventEmitter<boolean>(false)
  ngOnInit(): void {
    this.defaulLangauage()
    this.getDataErpInLocalstorage()
  }

  constructor(private translate: TranslateService, private router: Router) { }

  getCurentLanguageInLoacalStorage() {
    return localStorage.getItem('Language');
  }

  defaulLangauage() {
    // let currentLang = localStorage.getItem('Language');
    let currentLang = this.getCurentLanguageInLoacalStorage();
    if (!currentLang) {
      currentLang = 'en';
      localStorage.setItem('Language', currentLang);
    }
    this.translate.use(currentLang);
    this.translate.get(`lang.${currentLang}`).subscribe(res => {
      this.translation = res;
    });
  }



  onToggelMenue() {
    this.collapsedState = !this.collapsedState;
    this._collapsed.emit(this.collapsedState)
  }

  onToggelTranslation() {
    this.toggeltranslation = !this.toggeltranslation
  }


  ChangeLangauage(lang: string) {
    this.translation = this.translate.instant(`lang.${lang}`);
    this.toggeltranslation = false
    //  let currentLang = localStorage.getItem('Language');
    let currentLang = this.getCurentLanguageInLoacalStorage()
    if (currentLang) {
      localStorage.setItem('Language', lang);
      window.location.reload()
    }
  }

  backHome() {
    this.router.navigate(['../'])
  }

  getDataErpInLocalstorage() {
    let session = sessionStorage.getItem('data');
    if (session) {
      let parseData = JSON.parse(session);
      this.data = parseData
    }
  }


  getName(item: any): string {
    //  let currentLang = localStorage.getItem('Language') || 'en';
    let currentLang = this.getCurentLanguageInLoacalStorage() || 'en';
    return currentLang === 'ar' ? item.nameAr : item.nameEn;
  }


  Search(event: any) {
    let value = event.target.value.toLowerCase();
    //  let currentLang = localStorage.getItem('Language') || 'en';
    let currentLang = this.getCurentLanguageInLoacalStorage() || 'en';
    if (value) {
      this.popupsearch = true
      if (currentLang == 'ar') {
        this.data.navihationMenu = this.data.navihationMenu.filter((ele: any) =>
          ele.nameAr.toLowerCase().includes(value)
        );
      } else {
        this.data.navihationMenu = this.data.navihationMenu.filter((ele: any) =>
          ele.nameEn.toLowerCase().includes(value)
        );
      }
    }

    else {
      this.getDataErpInLocalstorage();
      this.popupsearch = false
    }
  }

  onNavigationRoute(item: any, value: HTMLInputElement) {
    this.router.navigate([item.externalUrl]);
    this.popupsearch = false
     value.value = ''; 
  this.getDataErpInLocalstorage()
  }
}

@NgModule({
  imports: [
    CommonModule,
    DxButtonModule,
    UserPanelModule,
    SharedModule,
    SharedComponentModule,
    DxMenuModule,
    ThemeSelectorModule
  ],
  declarations: [HeaderComponent],
  exports: [HeaderComponent]
})
export class HeaderModule { }
